import { BaseRepository } from "@/repositories/base-repository"
import { type IAvailabilityBucket } from "@/interfaces/api/availability-bucket.interface.ts"

export class AvailabilityBucketRepository extends BaseRepository<IAvailabilityBucket> {
  protected resourcePath = "core/availability-buckets"
}
